<template>
  <report
    :title="$t('language.yearlylateinearlyout')"
    :filter="filter"
    :url="url"
  >
    <template v-slot:filter>
      <v-flex xs12 sm12 md3>
        <ValidationProvider
          :name="$t('language.year')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.year"
            :items="YearList"
            item-text="name"
            item-value="id"
            :label="$t('language.year')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <ValidationProvider
          :name="$t('language.person')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.personid"
            :items="PersonList"
            item-text="name"
            item-value="id"
            :label="$t('language.person')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.branchid"
          :items="BranchList"
          item-text="name"
          item-value="id"
          :label="$t('language.branch')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.departmentid"
          :items="DepartmentList"
          item-text="name"
          item-value="id"
          :label="$t('language.department')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.designationid"
          :items="DesignationList"
          item-text="name"
          item-value="id"
          :label="$t('language.designation')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.modeid"
          :items="ModeList"
          item-text="name"
          item-value="id"
          :label="$t('language.mode')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.status"
          :items="StatusList"
          item-text="name"
          item-value="id"
          :label="$t('language.status')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
    </template>
    <template v-slot:printheader>
      <table class="printheader">
        <tbody>
          <tr>
            <td>{{ $t("language.year") }}:{{ selectedyear }}}</td>
            <td></td>
            <td>{{ $t("language.person") }}:{{ selectedperson }}</td>
            <td></td>
            <td>{{ $t("language.branch") }}:{{ selectedbranch }}</td>
            <td></td>
            <td>{{ $t("language.department") }}:{{ selecteddepartment }}</td>
            <td></td>
            <td>{{ $t("language.designation") }}:{{ selecteddesignation }}</td>
            <td></td>
            <td>{{ $t("language.mode") }}:{{ selectedmode }}</td>
            <td></td>
            <td>{{ $t("language.status") }}:{{ selectedstatus }}</td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-slot:table="{ data }">
      <table class="table table-bordered w-100">
        <thead>
          <tr>
            <th>{{ $t("language.date") }}</th>
            <th>{{ $t("language.officehour") }}</th>
            <th>{{ $t("language.intime") }}</th>
            <th>{{ $t("language.outtime") }}</th>
            <th>{{ $t("language.remarks") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ getDefaultDate(item.date) }}</td>
            <td>{{ item.officehour }}</td>
            <td>{{ item.intime }}</td>
            <td>{{ item.outtime }}</td>
            <td>
              {{
                item.latein
                  ? $t("language.latein") +
                    " - " +
                    $t("language." + item.lateinstatus) +
                    "(" +
                    item.lateintime +
                    ")"
                  : ""
              }}
              {{
                item.earlyout
                  ? $t("language.earlyout") +
                    " - " +
                    $t("language." + item.earlyoutstatus) +
                    "(" +
                    item.earlyouttime +
                    ")"
                  : ""
              }}
            </td>
          </tr>
        </tbody>
        <tfoot v-if="data.length == 0">
          <tr>
            <th colspan="5">{{ $t("language.nodatafound") }}</th>
          </tr>
        </tfoot>
      </table>
    </template>
  </report>
</template>
<script>
import axios from "axios";
import moment from "moment";
import Report from "../Report";
import commonservice from "../../../../shared/common.service";
export default {
  components: {
    Report,
  },
  data() {
    return {
      filter: {
        year: commonservice.getCurrentYear(),
        personid: null,
        branchid: null,
        departmentid: null,
        designationid: null,
        modeid: null,
        status: null,
      },
      YearList: [],
      PersonList: [],
      BranchList: [],
      DepartmentList: [],
      DesignationList: [],
      ModeList: [],
      StatusList: commonservice.LateInEarlyOutStatusList,
      url: "client/report/yearly/lateinearlyouts",
    };
  },
  computed: {
    selectedyear() {
      if (this.filter.year == null) return this.$t("language.all");
      return this.YearList.filter((c) => {
        return c.id == this.filter.year;
      })[0].name;
    },
    selectedperson() {
      if (this.filter.personid == null) return this.$t("language.all");
      return this.PersonList.filter((c) => {
        return c.id == this.filter.personid;
      })[0].name;
    },
    selectedbranch() {
      if (this.filter.branchid == null) return this.$t("language.all");
      return this.BranchList.filter((c) => {
        return c.id == this.filter.branchid;
      })[0].name;
    },
    selecteddepartment() {
      if (this.filter.departmentid == null) return this.$t("language.all");
      return this.DepartmentList.filter((c) => {
        return c.id == this.filter.departmentid;
      })[0].name;
    },
    selecteddesignation() {
      if (this.filter.designationid == null) return this.$t("language.all");
      return this.DesignationList.filter((c) => {
        return c.id == this.filter.designationid;
      })[0].name;
    },
    selectedmode() {
      if (this.filter.modeid == null) return this.$t("language.all");
      return this.ModeList.filter((c) => {
        return c.id == this.filter.modeid;
      })[0].name;
    },
    selectedstatus() {
      if (this.filter.status == null) return this.$t("language.all");
      return this.StatusList.filter((c) => {
        return c.id == this.filter.status;
      })[0].name;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/report/yearly/init/list").then((response) => {
      next((p) => {
        p.DepartmentList = response.data.departments;
        p.BranchList = response.data.branches;
        p.DesignationList = response.data.designations;
        p.ModeList = response.data.modes;
        p.YearList = response.data.years;
        p.PersonList = response.data.persons;
      });
    });
  },
  methods: {
    getDefaultDate(date) {
      return commonservice.getDefaultDate(date);
    },
  },
};
</script>
